import { StaticImageData } from 'next/legacy/image'
import Link from 'next/link'
import styled from 'styled-components'

import { colors } from '@/styles'
import Avatar from '@/components/avatar'
import { ParagraphMedium, ParagraphRegular } from '@/components/text'

const Card = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: 32px;
  box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.1), 0px 1px 2px rgba(0, 0, 0, 0.06);
  border-radius: 8px;
`

const CardHeader = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 16px;
`

const NameWrapper = styled.div`
  display: flex;
  flex-direction: column;
`

const NameText = styled(ParagraphRegular)`
  font-weight: 700;
  margin-right: 8px;
`

const RoleText = styled(ParagraphMedium)`
  color: ${colors.grey32};
`

const RoleLink = styled(ParagraphMedium)`
  color: ${colors.link};
  font-weight: 500;
  text-decoration: none;
  line-height: 16px;
`

interface Props {
  avatar: string | StaticImageData
  name: string
  company: string
  companyLink?: string
  review: string | JSX.Element
}

const TestimonialCard: React.FC<Props> = ({
  avatar,
  name,
  company,
  companyLink,
  review
}) => {
  return (
    <Card>
      <CardHeader>
        <Avatar width={32} height={32} right={24} location={avatar} />
        <NameWrapper>
          <NameText>{name}</NameText>
          {companyLink ? (
            <Link href={companyLink} passHref legacyBehavior>
              <RoleLink as="a">{company}</RoleLink>
            </Link>
          ) : (
            <RoleText>{company}</RoleText>
          )}
        </NameWrapper>
      </CardHeader>
      <ParagraphRegular>{review}</ParagraphRegular>
    </Card>
  )
}

export default TestimonialCard
